module.exports = __webpack_public_path__ + "img/nav_group_white.ebc927ae.png";